/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import './footer.css'
import {FaAngellist, FaTwitter, FaGithub, FaLinkedin, FaMedium, FaYoutube} from 'react-icons/fa'

const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer_logo'>hospice</a>
      <ul className='permalinks'>
        <li><a href='#'>Home</a></li>
        <li><a href='#about'>About</a></li>
        <li><a href='#projects'>Projects</a></li>
        <li><a href='#experience'>Experience</a></li>
        <li><a href='#licenses-certifications'>Certificats</a></li>        
        {/* <li><a href='#testimonials'>Testimonials</a></li> */}
        <li><a href='#contact'>Contact</a></li>
      </ul>
      <div className="footer_socials">
        <a href="https://www.linkedin.com/in/hospice-hounfodji-44a2a7235/"  target="_blank" rel="noreferrer"><FaLinkedin /></a>
        <a href="https://github.com/hounfodji"  target="_blank" rel="noreferrer"><FaGithub /></a>
        <a href="https://medium.com/@hospicehounfodji"  target="_blank" rel="noreferrer"><FaMedium /></a>
        <a href="https://www.youtube.com/@hospicehounfodji4378"  target="_blank" rel="noreferrer"><FaYoutube /></a>
        <a href="https://x.com/HRHounfodji?s=35"  target="_blank" rel="noreferrer"><FaTwitter /></a>        
      </div>
      <div className="footer_copyright">
        <small>&copy; hospice Portfolio. All rights reserved.</small>
      </div>
    </footer>
  )
}

export default Footer